import {
  Component,
  OnInit,
  ChangeDetectorRef
} from "@angular/core";
import {
  trigger,
  transition,
  style,
  animate,
} from "@angular/animations";
import { Subscription } from "rxjs/Subscription";
import { FormControl } from "@angular/forms";
import { NotificationsService } from "angular2-notifications";
import {
  SelectionLists,
  CurrentSelection,
  Equipment,
  Customer,
  JobSite,
  Model,
  Make
} from "../../../entities";
import { AppService } from "../../../app.service";
import { TranslateService } from "../../../translate";
import { LoadingService } from "../../../shared/services/loading.service";
import {
  InventorySearchItems,
  SystemsInInventoryViewModel,
  SystemComponentViewModel,
  InventoryComponentMetadata,
  InventoryComponentValue
} from "../inventory-models";
import { InventoryService } from "../inventory-service.service";
import { SystemInventoryManagementComponent } from "../inventory-management/system-inventory-management/system-inventory-management.component";
import { WsreCreateNewInspectionComponent } from "../inventory-management/wsre-create-new-inspection/wsre-create-new-inspection.component";
import { Router, ActivatedRoute } from '@angular/router';
import { InventoryOrWsreDialogComponent } from "../inventory-or-wsre-dialog/inventory-or-wsre-dialog.component";
import { WsreQuickFrameComponent } from "../../wsre-quick-frame/wsre-quick-frame.component";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InventoryReportConfigurationComponent } from "../../dashboard/inventory-report-configuration/inventory-report-configuration.component";

export interface System {
  Id: number;
  SerialNumber: string;
  JobSiteId: number;
}

animations: [
  trigger(
    'enterAnimation', [
    transition(':enter', [
      style({ transform: 'translateY(25%)', opacity: 0 }),
      animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
    ]),
    transition(':leave', [
      style({ transform: 'translateY(0)', opacity: 1 }),
      animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
    ])
  ]
  )]

@Component({
  selector: "app-inventory",
  templateUrl: "./inventory.component.html",
  styleUrls: ["./inventory.component.scss"],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms", style({ opacity: 1 }))
      ]),
      transition(":leave", [
        style({ opacity: 0 }),
        animate("0ms", style({ opacity: 0 }))
      ])
    ]),
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(25%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ]
    )
  ],
  providers: [InventoryService]
})
export class InventoryComponent implements OnInit {
  translateSubscription: Subscription;
  userLanguage = "english";
  _loading = 0;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();
  _returnRoute = "";
  _selectedEquipment: Equipment = new Equipment();
  //separatorKeysCodes = [ENTER, COMMA];
  items: SystemsInInventoryViewModel[] = [];
  inventorySearchFilter: InventorySearchItems = new InventorySearchItems(2000); // todo : should implement paged table
  equipmentCtrl: FormControl;
  filteredSystems: SystemsInInventoryViewModel[] = [];
  selectedCustomer: Customer;
  isLoading = false;
  selectedJobsite: JobSite;
  selectedStatus: number;
  selectedType: number;
  selectedMake: Make;
  selectedModel: Model;
  private _listFilter: string = "";
  ShowBoth: boolean = false;
  showRelatedModel: boolean = false;
  excludeScrap: boolean = true;
  totalcount = 0;
  avaragecmu = 0;
  chainId: number;
  jobSiteID: number;
  componenetsdetails: SystemComponentViewModel[];
  SystemId: number;
  makeModel: string = "";
  makeTitle: string = "";
  machineModel: string = "";
  customerModel: string = "";
  customerId: number = 0;
  jobsite: number = 0;
  pageNumber: number = 0;
  inventoryPerPage: number = 50;
  totalResults: number = 0;
  isSearchVisible: boolean = true;
  isOptionsVisible: boolean = true;
  isWSREEnable: boolean = false;
  arrSystems: System[];
  make_auto_: number;
  modelTitle: string = "";
  model_auto_: number;

  componentValues: InventoryComponentValue[] = [];
  componentColumns: InventoryComponentMetadata[] = [];

  public get listFilter(): string {
    return this._listFilter;
  }
  public set listFilter(v: string) {
    this._listFilter = v;
    this.filteredSystems = this.listFilter
      ? this.performFilter(this.listFilter)
      : this.items;
  }

  performFilter(filter: string): SystemsInInventoryViewModel[] {
    filter = filter.toLowerCase();
    return this.items?.filter(s => {
      // tslint:disable-next-line:no-unused-expression

      return s.SerialNumber.toLowerCase().indexOf(filter) !== -1;
    });
  }

  constructor(
    private _appService: AppService,
    private _translate: TranslateService,
    public snackBar: MatSnackBar,
    private _notification: NotificationsService,
    private _loadingService: LoadingService,
    private inventoryService: InventoryService,
    private _dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private _router: ActivatedRoute,
    private router: Router
  ) { }
  ngOnInit() {
    this.SystemId = this._router.snapshot.params.id;
    // this.chainId = this._router.snapshot.params.id
    // this.jobSiteID = this._router.snapshot.params.jobsiteId
    // if(this.chainId && this.jobSiteID){
    // }
    // console.log("chainId",this.chainId)
    // this.getInventoryStatusDropdownList();
    this._dropDownLists.type = [
      { Id: 1, Title: 'Chains' }, { Id: 2, Title: 'Frames' }, { Id: 3, Title: 'Idlers' }]
    this._appService.setPageTitle("Inventory");
    this._loading++;
    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;

        this._dropDownListsFiltered.customerList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.jobSiteList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getMakeListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.makeList = result;
        this._dropDownListsFiltered.makeList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getModelListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.modelList = result;
        console.log('Modelresult', result)
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }

  onPageEvent(event: any) {
    this.pageNumber = event.pageIndex;
    this.inventoryPerPage = event.pageSize;
    this.search();
  }

  getInventoryStatusDropdownList(id: number) {
    let systemTypeName = id == 1 ? 'Chain' : ''
    this._appService.getLUUCInventoryStatusDropdownList(systemTypeName).subscribe(
      result => {
        this._dropDownLists.inventoryStatus = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
  }

  gotoScreen(screen: number) {
    let path = ""
    if (screen == 1) {
      path = `/1/${this.customerId}/${this.jobsite}`;
    } else if (screen == 2) {
      path = `/2/${this.customerId}/${this.jobsite}`;
    } else if (screen == 3) {
      path = `/3/${this.customerId}/${this.jobsite}`;
    }
    this.router.navigateByUrl(`/setup-undercarriage/in-inventory${path}`);
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  ResetFields() {
    this.resetModel();
    this.resetMake();
    this.resetCustomer();
    this.resetJobsite();
    this.resetType();
    this.selectedStatus = null;
    this.selectedType = null;
    this.listFilter = "";
    this.filteredSystems = null;
    this.ShowBoth = false;
    this.showRelatedModel = false;
    this.makeModel = "";
    this.machineModel = "";
    this.customerModel = "";
    this.excludeScrap = true;
    this.pageNumber = 0;
    this.inventoryPerPage = 50;
    this.totalResults = 0;
  }

  changePageSize(size: number) {
    this.inventoryPerPage = size;
    this.pageNumber = 0;   // optional
    this.search();
  }

  getBoth() {
    console.log("SHow__", this.ShowBoth)
    this.inventorySearchFilter.ShowBoth = this.ShowBoth;
  }

  showRelated() {
    this.inventorySearchFilter.showRelatedModel = this.showRelatedModel;
  }

  ExcludeScrap() {
    this.inventorySearchFilter.ExcludeScrap = this.excludeScrap;
  }

  getComponentValue(item: SystemsInInventoryViewModel,
    componentName: string,
    positionNo: number, componentTypeId: number): number {

    const value = this.componentValues.find(x =>
      x.ModuleUcsubAuto === item.SystemId &&
      x.ComponentName === componentName &&
      x.PositionNo === positionNo &&
      x.ComponentTypeId === componentTypeId);
    //console.log("value,: ", value);
    return value ? value.WornPercentage : 0;
  }

  searchRecords() {
    this.pageNumber = 0;
    this.search();
  }

  search() {
    this.isOptionsVisible = false;
    //this.isSearchVisible = false;
    this._loadingService.startLoading();
    this.isLoading = true;
    this.inventorySearchFilter.SerialNo = this.listFilter;
    this.inventorySearchFilter.ExcludeScrap = this.excludeScrap;
    this.inventorySearchFilter.PageNumber = this.pageNumber + 1;
    this.inventorySearchFilter.ItemPerPage = this.inventoryPerPage == 0 ? 50 : this.inventoryPerPage;
    this.inventoryService
      .searchSystemInInventory(this.inventorySearchFilter)
      .subscribe(
        r => {
          if (r != null && r?.TotalRecords > 0) {
            console.log("searchSystemInInventory: ", r);
            this.items = r.ListSystemInventory;
            this.totalResults = r.TotalRecords;
            this.isWSREEnable = r.isWSREEnable;

            this.componentValues = r.InventoryComponentValues || [];
            this.componentColumns = r.InventoryComponentMetadata || [];
            console.log("this.componentValues: ", this.componentValues);
            console.log("this.componentColumns: ", this.componentColumns);

            let _filteredSystems = r.ListSystemInventory;
            if (this.SystemId > 0) {
              if (this.SystemId == 1) {
                _filteredSystems = r.ListSystemInventory
                  .filter(f => f.SystemTypeName == "Chain");
              }
              else if (this.SystemId == 2) {
                _filteredSystems = r.ListSystemInventory
                  .filter(f => f.SystemTypeName == "Frame");
              }
              else if (this.SystemId == 3) {
                _filteredSystems = r.ListSystemInventory
                  .filter(f => f.SystemTypeName == "Idler");
              }
            }
            if (_filteredSystems?.length > 0) {
              let arr_ = [];
              let promiseSystems = _filteredSystems.map(async systems => {
                let obj_ = {};
                obj_["Id"] = systems.SystemId;
                obj_["SerialNumber"] = systems.SerialNumber;
                obj_["JobSiteId"] = systems.JobSiteId;
                arr_.push(obj_);
                return systems;
              });
              Promise.all(promiseSystems)
                .then((res) => {
                  this.filteredSystems = res;
                  this.finishedLoading();
                });
              this.arrSystems = arr_;
            } else {
              this.finishedLoading();
            }
          }
          else {
            this._notification.alert('No record(s) found!');
            this.items = [];
            this.componentValues = [];
            this.componentColumns = [];
            this.finishedLoading();
          }
        },
        error => {
          this.finishedLoading();
        }
      );
  }
  //search() {
  //  this._loadingService.startLoading();
  //  this.isLoading = true;
  //  this.inventorySearchFilter.SerialNo = this.listFilter;
  //  this.inventorySearchFilter.ExcludeScrap = this.excludeScrap;
  //  this.inventorySearchFilter.PageNumber = this.pageNumber + 1;
  //  this.inventorySearchFilter.ItemPerPage = this.inventoryPerPage == 0 ? 50 : this.inventoryPerPage;
  //  this.inventoryService
  //    .searchSystemInInventory(this.inventorySearchFilter)
  //    .subscribe(
  //      r => {
  //        if (r != null) {
  //          this.items = r.ListSystemInventory;
  //          this.totalResults = r.TotalRecords;
  //          let _filteredSystems = r.ListSystemInventory;
  //          if (this.SystemId > 0) {
  //            //_filteredSystems = r.ListSystemInventory.filter(f => f.SystemType == this.SystemId);

  //            //TT-5846
  //            if (this.SystemId == 1) {
  //              _filteredSystems = r.ListSystemInventory.filter(f => f.SystemTypeName == "Chain");
  //            }
  //            else if (this.SystemId == 2) {
  //              _filteredSystems = r.ListSystemInventory.filter(f => f.SystemTypeName == "Frame");
  //            }
  //            else if (this.SystemId == 3) {
  //              _filteredSystems = r.ListSystemInventory.filter(f => f.SystemTypeName == "Idler");
  //            }
  //            //end TT-5846
  //          }



  //          //TT-2355
  //          //console.log("filteredSystems", r)
  //          //check site enable for WSRE
  //          this.isWSREEnable = r.isWSREEnable;


  //          if (_filteredSystems?.length > 0) {
  //            let arr_ = []

  //            let promiseSystems = _filteredSystems.map(async systems => {
  //              let obj_ = {}

  //              obj_["Id"] = systems.SystemId
  //              obj_["SerialNumber"] = systems.SerialNumber
  //              obj_["JobSiteId"] = systems.JobSiteId

  //              arr_.push(obj_)

  //              //let response = await this.inventoryService
  //              //  .getSystemComponentsInfo(systems.SystemId).toPromise();
  //              //systems.Components = response;
  //              return systems;
  //            });
  //            Promise.all(promiseSystems).then((res) => {
  //              //console.log("Promise", res)
  //              //this.filteredSystems = res
  //              //this.filteredSystems.map(systems => {
  //              //  let totalCMU = 0;
  //              //  systems.Components.forEach(comp => {
  //              //    this.totalcount = systems.Components.length;
  //              //    totalCMU = comp.CMU + totalCMU;
  //              //  });

  //              //  this.avaragecmu = parseFloat((totalCMU / this.totalcount).toFixed(2));
  //              //  systems.AverageCMU = this.avaragecmu;

  //              //})

  //              this.filteredSystems = res
  //              this.finishedLoading();
  //            })

  //            this.arrSystems = arr_

  //          } else {
  //            this.finishedLoading();
  //          }
  //        }
  //        else {
  //          this._notification.success('No record(s) found!');
  //          this.finishedLoading();
  //        }
  //        this.finishedLoading();
  //      },
  //      error => {
  //        this.finishedLoading();
  //      }
  //    );
  //}

  finishedLoading() {
    this._loadingService.finishedLoading();
    this.isLoading = false;
  }
  // customerChanged(event: any): void {
  //   this.selectedCustomer = event.value;
  //   if (!this.selectedCustomer) {
  //     return;
  //   }
  //   this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
  //     m => m.CustomerId === this.selectedCustomer.Id
  //   );
  //   this.inventorySearchFilter.CustomerId = this.selectedCustomer.Id;
  //   this.inventorySearchFilter.JobsiteId = 0;
  //   this.selectedJobsite = null;
  //   this.resetModel();
  //   this.resetMake();
  //   //this.search();
  // }

  customerChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.customerList = this._dropDownLists.customerList.filter(option => option.Title.toLowerCase().includes(filterValue));
      //     this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      //   m => m.CustomerId === this.selectedCustomer.Id
      // );
      // this.inventorySearchFilter.CustomerId = this.selectedCustomer.Id;
      // this.inventorySearchFilter.JobsiteId = 0;
      // this.selectedJobsite = null;
      // this.resetModel();
      // this.resetMake();
      //this.search();


    }
    else {
      this.resetModel();
      this.resetMake();
    }

  }

  onSelectCustomer(event: any) {
    let id = this._dropDownListsFiltered.customerList.find(f => f.Title == event.value).Id
    this.customerId = id
    this.inventorySearchFilter.CustomerId = id;
    this._dropDownListsFiltered.jobSiteList = null;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      m => m.CustomerId === id
    );
  }

  jobsiteChanged(event: any): void {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
    this.jobsite = this.selectedJobsite.Id;
    this.inventorySearchFilter.JobsiteId = this.selectedJobsite.Id;
    if (event.target)
      this.jobsite = event.target.value;
    this.resetModel();
    this.resetMake();
    // this.search();
  }

  // makeChanged(event) {
  //   this.selectedMake = event.value;
  //   if (!this.selectedMake) {
  //     return;
  //   }
  //   this.inventorySearchFilter.MakeId = this.selectedMake.Id;
  //   console.log(this._dropDownLists.modelList);
  //   console.log(this.selectedMake);
  //   this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
  //     m => m.MakeId === this.selectedMake.Id
  //   );
  // }

  changedInventoryStatus(event: any): void {
    this.selectedStatus = event.value;
    //if (!this.selectedStatus) {
    //  return;
    //}
    this.inventorySearchFilter.InventoryStatusId = this.selectedStatus;
    //this.resetModel();
    //this.resetMake();
    // this.search();
  }

  changedMake(event: any) {
    if (event.target) {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.makeList = this._dropDownLists.makeList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }
    //else {
    //  this.resetModel();
    //  this.resetMake();
    //}
  }


  onSelectMake(event: any) {
    let id = this._dropDownListsFiltered.makeList.find(f => f.Title == event.value).Id
    this.inventorySearchFilter.MakeId = id;
    this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
      m => m.MakeId === id
    );
  }

  changedModel(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }
    else {
      this.resetModel();
    }
  }

  onSelcetionModel(event: any) {
    let id = this._dropDownListsFiltered.modelList.find(f => f.Title == event.value).Id
    this.inventorySearchFilter.ModelId = id;
  }

  typeChanged(event) {
    this.selectedType = event.value;
    this.inventorySearchFilter.TypeId = event.value
    this.getInventoryStatusDropdownList(this.selectedType)
    //this.search();
  }

  resetMake() {
    this.inventorySearchFilter.MakeId = 0;
    this.selectedMake = null;
    this._dropDownListsFiltered.makeList = this._dropDownLists.makeList;
  }

  resetModel() {
    this.inventorySearchFilter.ModelId = 0;
    this.selectedModel = null;
    this._dropDownListsFiltered.modelList = this._dropDownLists.modelList;
  }

  resetJobsite() {
    this.inventorySearchFilter.JobsiteId = 0;
    this.selectedJobsite = null;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList;
  }

  resetCustomer() {
    this.inventorySearchFilter.CustomerId = 0;
    this.selectedCustomer = null;
    this._dropDownListsFiltered.customerList = this._dropDownLists.customerList;
  }

  resetType() {
    this.inventorySearchFilter.TypeId = 0;
    this.selectedType = null;
    //this._dropDownListsFiltered.makeList = this._dropDownLists.makeList;
  }


  openSelcetionDilaog(item) {
    const dialogRef = this._dialog.open(InventoryOrWsreDialogComponent, {
      panelClass: "removeModalOverflowTest",
      data: {
        item: item
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(changed => {
      if (changed == 0) {
      }
      // else if (changed == 1) {
      //   //this.open(item);
      // } 
      else if (changed == 2) {
        this.onClickStartInspection(item)
      } else if (changed == 3) {
        this.OpenWSREInspectionPopUpFrame(item.SystemId, item.ystemId, item.JobSiteId, item.SerialNumber, item.SerialNumber);
      }
    });
  }

  OpenWSREInspectionPopUpFrame(systemIdL: number, systemIdR: number, jobsiteId: number, serialL: string, serialR: string) {
    const dialogRef = this._dialog.open(WsreQuickFrameComponent, {
      panelClass: "removeModalOverflowTest",
      data: {
        selected_frame_L: serialL,
        selected_frame_R: serialR,
        selected_frame_L_Id: systemIdL,
        selected_frame_R_Id: systemIdR,
        jobsites: jobsiteId,
        isInventory: true,
        isCreateNew: true,
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
      }
    });
  }

  //open(item) {
  openSelcetionDilaogInspect(item) {
    const dialogRef = this._dialog.open(SystemInventoryManagementComponent, {
      /*panelClass: "removeModalOverflowTest",*/
      width: "80%",
      height: "90%",
      data: {
        system: item,
        customer: this.selectedCustomer,
        customers: this._dropDownLists.customerList,
        jobsites: this._dropDownLists.jobSiteList
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
        this.search();
      }
    });
  }

  onClickStartInspection(item) {
    if (item == null) {
      return
    }
    //getCOmponentsForSYstem 
    let filSystems = this.filteredSystems != null ? this.filteredSystems.find(f => f.SystemId == item.SystemId) : null
    this.inventoryService.getSystemComponentsInfo(item.SystemId).subscribe(res => {
      console.log("res__", res)
      filSystems.Components = res;
      console.log("filSystems__", filSystems)
      let filteredIdlers = item.SystemType == 3 ? filSystems != null && filSystems.Components != null ? filSystems.Components.filter(f => f.CompartType == 233) : [] : filSystems.Components
      const dialogRef = this._dialog.open(WsreCreateNewInspectionComponent, {
        panelClass: "removeModalOverflowTest",
        data: {
          systemId: item.SystemType == 3 ? 2 : item.SystemType,
          system: item,
          customer: this.selectedCustomer,
          customers: this._dropDownLists.customerList,
          jobsites: this._dropDownLists.jobSiteList,
          systemList: this.arrSystems,
          componentList: filteredIdlers
        },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(changed => {
        if (changed) {
        }
      });
    })
  }

  openReport() {
    const dialogRef = this._dialog.open(InventoryReportConfigurationComponent, {
      panelClass: "removeModalOverflowTest",
      data: {
        item: { id: 10 }
      },
      autoFocus: false,
      disableClose: true
    });
  }

  downloadPDF(item) {
    //this._loadingService.startLoading();
    window.open(this._appService.getBaseURL() + '/api/Dashboard/GetInventoryReportPdf?cu=' + item.CustomerId + "&jb=" + item.JobSiteId + "&SystemId=" + item.SystemId, '_blank');
  }
  getRepairTooltip(item: any): string {
    if (item.InventoryStatusId !== 7) {
      return 'Download PDF';
    }
    const systemName = item.SystemType === 1 ? 'Chain' : item.SystemType === 2 ? 'Frame' : 'Idler';
    return `This ${systemName} is undergoing repair in WSRE. Please make any changes through WSRE. Once the repair is complete, you will be able to adjust in inventory again.`;
  }
}
